(function($){

	jQuery.fn.ebcaptcha = function(options){

		var element = this; 
		//var submit = $(this).find('input[type=submit]');
        //$('<label id="ebcaptchatext"></label>').insertBefore(submit);
		//$('<input type="text" required class="textbox" id="ebcaptchainput"/><br/>').insertBefore(submit);
        
        var submit = $(this).find('input[type=password]');
		
		$('<input type="text" required class="textbox" id="ebcaptchainput"/><br/>').insertAfter(submit);
        $('<label id="ebcaptchatext"></label>').insertAfter(submit);
      
		var input = this.find('#ebcaptchainput'); 
		var label = this.find('#ebcaptchatext'); 
		
		$(element).find('input[type=submit]').attr('disabled','disabled'); 

		
		var randomNr1 = 0; 
		var randomNr2 = 0;
		var totalNr = 0;


		randomNr1 = Math.floor(Math.random()*10);
		randomNr2 = Math.floor(Math.random()*10);
		totalNr = randomNr1 + randomNr2;
        var textj=document.body.getAttribute('data-lang') == 'fr' ? 'Qu’est ce que la' : 'What is';
		var texti = "<b>Captcha:</b> " +textj+" "+randomNr1+" + "+randomNr2+" ? ";
        
		$(label).html(texti);
		
	
		$(input).keyup(function(){

			var nr = $(this).val();
			if(nr==totalNr)
			{
				$(element).find('input[type=submit]').removeAttr('disabled');				
			}
			else{
				$(element).find('input[type=submit]').attr('disabled','disabled');
			}
			
		});

		$(document).keypress(function(e)
		{
			if(e.which==13)
			{
				if((element).find('input[type=submit]').is(':disabled')==true)
				{
					e.preventDefault();
					return false;
				}
			}

		});

	};

})(jQuery);